export default __webpack_public_path__ + "static/media/order2.8f63f106.svg";